import * as React from 'react';
import { X } from 'lucide-react';
import { cn } from '../lib/utils.js';

export type OverlayCloseButtonProps = Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  'className'
>;

/**
 * Overlay close/remove button -- appears on hover over a `group` parent.
 * Parent must have `className="group relative"` for hover reveal to work.
 */
const OverlayCloseButton = React.forwardRef<HTMLButtonElement, OverlayCloseButtonProps>(
  (props, ref) => {
    return (
      <button
        type="button"
        className={cn(
          'absolute top-1.5 right-1.5 h-6 w-6 rounded-full',
          'bg-background/80 backdrop-blur-sm',
          'opacity-0 group-hover:opacity-100 transition-opacity',
          'inline-flex items-center justify-center',
          'hover:bg-destructive hover:text-white',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
          'disabled:pointer-events-none disabled:opacity-50',
        )}
        ref={ref}
        {...props}
      >
        <X className="h-3 w-3" />
      </button>
    );
  },
);
OverlayCloseButton.displayName = 'OverlayCloseButton';

export { OverlayCloseButton };
